import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import {
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
} from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withServerError } from '@bingads-webui-react/validation';

export const ErrorDialog = withServerError((props) => {
  const {
    buttonText,
    title,
    onClick,
    dialogClass,
    validationProps,
  } = props;
  const {
    passiveMessages,
  } = validationProps;
  const i18n = useContext(I18nContext);

  const dialogContentProps = useMemo(() => ({
    type: DialogType.normal,
    title,
    subText: _.first(passiveMessages) || '',
    showCloseButton: false,
  }), [passiveMessages, title]);
  return (
    <Dialog
      hidden={_.isEmpty(passiveMessages)}
      dialogContentProps={dialogContentProps}
      modalProps={{
        className: `${dialogClass}-error-dialog`,
        isBlocking: true,
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={onClick} className={`${dialogClass}-primary-button`} >
          {buttonText || i18n.getString(_TL_('OK'))}
        </PrimaryButton>
      </DialogFooter>
    </Dialog >
  );
});

ErrorDialog.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  dialogClass: PropTypes.string,
};

ErrorDialog.defaultProps = {
  buttonText: null,
  dialogClass: 'error-dialog',
};
